var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "sale-monter-header" }, [
        _c(
          "div",
          { staticClass: "brand" },
          [
            _c("nav", { staticClass: "navbar navbar-default" }, [
              _c(
                "button",
                {
                  staticClass: "navbar-toggle",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.$refs.sidebarMenu.handleTogglePageSmallMenu()
                    }
                  }
                },
                [
                  _c("i", {
                    class: ["fa", _vm.isSidebarOpen ? "fa-times" : "fa-bars"],
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "member-plan text-size-16",
                class: _vm.memberPlanClass
              },
              [_vm._v("\n        " + _vm._s(_vm.memberPlan) + "\n      ")]
            ),
            _vm._v(" "),
            _vm.isPremiumTrial ? _c("premium-trial") : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "categories" }, [
          _c("div", { staticClass: "box-notifications" }, [
            _c("div", { staticClass: "notifications" }, [
              _c("i", { staticClass: "fa fa-bell" }),
              _vm._v(" "),
              _c("span", { staticClass: "title-notifications" }, [
                _vm._v(" お知らせ")
              ]),
              _vm._v(" "),
              _vm.countNoticeUnread
                ? _c("span", { staticClass: "count-notice-unread" }, [
                    _vm._v(_vm._s(_vm.countNoticeUnread))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showHeaderListNotification,
                    expression: "showHeaderListNotification"
                  }
                ],
                staticClass: "header-list-notifications"
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _vm._l(_vm.notices, function(notice, noticeIndex) {
                  return _c(
                    "div",
                    {
                      key: "notice-key-" + noticeIndex,
                      staticClass: "notification"
                    },
                    [
                      _c("div", { staticClass: "notification-release-date" }, [
                        _vm._v(_vm._s(notice.date))
                      ]),
                      _vm._v(" "),
                      _c("a", {
                        class: {
                          "notification-content": true,
                          unread: !notice.is_notice_read
                        },
                        attrs: { href: "javascript:void(0)" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.replaceHTMLSellerInfo(notice.title)
                          )
                        },
                        on: {
                          click: function($event) {
                            _vm.handleViewNotice(notice)
                          }
                        }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "box-btn-view-all text-center",
                    on: {
                      click: function($event) {
                        _vm.handleViewAllNotice()
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn-view-all",
                        attrs: { href: "javascript:void(0)" }
                      },
                      [_vm._v("すべてのお知らせを表示する")]
                    )
                  ]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "seller-info text-white" }, [
            _c("div", [
              _vm._v("会員ID : "),
              _c("span", [_vm._v(_vm._s(_vm.userInfo.sellerId))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "span",
                {
                  class: {
                    "m-r-sm":
                      _vm.userInfo.companyName &&
                      _vm.userInfo.companyName.length > 0
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.userInfo.companyName || "") +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v("\n          " + _vm._s(_vm.sellerName) + "\n          ")
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("sidebar-menu", {
        ref: "sidebarMenu",
        on: { setSidebarMenuPageSmallMode: _vm.setSidebarMenuPageSmallMode }
      }),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "wrapper" } },
        [
          _vm.isChanged
            ? _c("reload-notification", {
                attrs: { "data-backdrop": "static", "data-keyboard": "false" },
                on: { reload: _vm.reload }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasReturnRecommend
            ? _c("div", { staticClass: "fba-longterm-stock font-bold" }, [
                _c("span", [
                  _c("i", {
                    staticClass: "fa fa-exclamation-triangle",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v("\n        FBAで無駄な手数料が "),
                  _c("span", { staticClass: "text-primary text-size-28" }, [
                    _vm._v(_vm._s(_vm.formatNumber(_vm.totalFbaFee)))
                  ]),
                  _vm._v(" 円発生しています！\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-warning",
                    on: {
                      click: function($event) {
                        _vm.$router.push("/salemon-agent")
                      }
                    }
                  },
                  [
                    _vm._v("\n        手数料を削減する\n        "),
                    _c("i", {
                      staticClass: "fa fa-chevron-circle-right",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "help-bubble-wrapper" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.helpData.length,
                    expression: "helpData.length"
                  }
                ],
                staticClass: "toggle-btn",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.toggleHelpBubble()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-question-circle",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" ヘルプ\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowBubble,
                    expression: "isShowBubble"
                  }
                ],
                ref: "helpBubble",
                staticClass: "help-bubble",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c(
                  "ul",
                  _vm._l(_vm.helpData, function(item, index) {
                    return _c("li", { key: index }, [
                      _c(
                        "a",
                        {
                          attrs: { href: item.url, target: "_blank" },
                          on: {
                            click: function($event) {
                              _vm.handleClickHelpLink(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.title))]
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.isShowPopup
            ? _c("popup", {
                attrs: { popupData: _vm.popupData },
                on: { close: _vm.handleClosePopup }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("router-view")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "navbar-brand sale-monter-logo", attrs: { href: "/" } },
      [
        _c("img", {
          staticClass: "img-responsive",
          attrs: { src: "/static/dists/img/logo.png" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "navbar-brand sale-monter-logo-mobi",
        attrs: { href: "/" }
      },
      [
        _c("img", {
          staticClass: "img-responsive",
          attrs: { src: "/static/dists/img/logomobi.png", alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-btn-close" }, [
      _c(
        "a",
        { staticClass: "btn-close", attrs: { href: "javascript:void(0)" } },
        [_vm._v("閉じる "), _c("i", { staticClass: "fa fa-times" })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24bec598", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24bec598","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainFrame.vue
// module id = null
// module chunks = 